// extracted by mini-css-extract-plugin
export default {"usluge":"Usluge_usluge__+Hjxf","main":"Usluge_main__pG1aq","title":"Usluge_title__NBNy-"};